import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/rimborsi")({
  head: () => seoMeta({
    title: "Politica di Rimborso - LexAIPro",
    description: "Politica di rimborso di LexAIPro: garanzia soddisfatti o rimborsati 30 giorni, gestita da Paddle.",
    path: "/rimborsi",
  }),
  component: () => (
    <ContentPage
      eyebrow="Legale"
      title="Politica di Rimborso"
      lead="Vogliamo che tu sia pienamente soddisfatto di LexAIPro. Per questo offriamo una garanzia soddisfatti o rimborsati di 30 giorni."
      breadcrumbs={[{ name: "Home", path: "/" }, { name: "Rimborsi", path: "/rimborsi" }]}
      sections={[
        {
          heading: "Garanzia 30 giorni",
          body: "Se non sei soddisfatto del tuo acquisto, puoi richiedere il rimborso integrale entro 30 giorni dalla data dell'ordine, senza dover fornire alcuna giustificazione.",
        },
        {
          heading: "Come richiedere il rimborso",
          body: "I rimborsi sono gestiti dal nostro fornitore di pagamenti Paddle, in qualità di Merchant of Record. Per richiedere un rimborso puoi:",
          bullets: [
            "Visitare il portale clienti di Paddle su paddle.net utilizzando l'email associata all'acquisto",
            "Contattare il nostro supporto a beleadcreativestudio@proton.me: inoltreremo la richiesta a Paddle",
            "Indicare il numero d'ordine o l'email utilizzata per facilitare la lavorazione",
          ],
        },
        {
          heading: "Tempistiche",
          body: "Le richieste di rimborso sono normalmente evase entro 5-10 giorni lavorativi. L'accredito sul metodo di pagamento originario può richiedere ulteriori giorni in funzione della banca o del circuito utilizzato.",
        },
        {
          heading: "Abbonamenti",
          body: "Puoi annullare il rinnovo automatico in qualsiasi momento dal portale clienti. La cancellazione ha effetto al termine del periodo di fatturazione corrente: continuerai ad avere accesso al piano fino a quella data.",
        },
        {
          heading: "Riferimenti",
          body: "Per i dettagli completi sulla gestione dei rimborsi puoi consultare la Refund Policy di Paddle: https://www.paddle.com/legal/refund-policy.",
        },
      ]}
      cta={{ label: "Contatta il supporto", to: "/contatti" }}
      heroImage={pickContent(11)}
      updated="Maggio 2026"
    />
  ),
});
